module.exports = __webpack_public_path__ + "static/media/LE.265503f1.svg";